import { useEffect, useState } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import './messageReply.css';

const mediaLabels = {
  image: 'Photo',
  video: 'Video',
  audio: 'Voice message',
  file: 'Attachment',
};

const safeImageUrl = (url) => {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol) &&
      !parsed.username &&
      !parsed.password
      ? parsed.href
      : '';
  } catch {
    return '';
  }
};

export default function MessageReplyPreview({
  replyTo,
  currentPlayerId,
  composer = false,
  own = false,
  pending = false,
  error = '',
  onCancel,
}) {
  const [failedImage, setFailedImage] = useState(false);
  useEffect(() => {
    setFailedImage(false);
  }, [replyTo?.mediaUrl]);
  if (!replyTo?.messageId && !pending && !error) return null;
  const name =
    String(replyTo?.sender) === String(currentPlayerId)
      ? 'yourself'
      : replyTo?.senderLabel || 'Player';
  const heading = composer
    ? `Replying to ${name}`
    : own
    ? `You replied to ${name}`
    : `Replied to ${
        String(replyTo?.sender) === String(currentPlayerId) ? 'you' : name
      }`;
  const imageUrl =
    replyTo?.mediaType === 'image' && !failedImage
      ? safeImageUrl(replyTo?.mediaUrl)
      : '';

  return (
    <div
      className={`messageReplyPreview${
        composer ? ' messageReplyComposer' : ''
      }`}
      aria-label={composer ? 'Reply preview' : 'Quoted message'}
    >
      <div
        className="messageReplyCopy"
        aria-live={composer ? 'polite' : undefined}
      >
        <div className="messageReplyHeading">
          {pending ? 'Loading reply...' : error ? 'Reply unavailable' : heading}
        </div>
        <div className="messageReplyText" role={error ? 'alert' : undefined}>
          {error ||
            replyTo?.text ||
            mediaLabels[replyTo?.mediaType] ||
            (pending ? '' : 'Message')}
        </div>
      </div>
      {imageUrl ? (
        <img
          className="messageReplyThumbnail"
          src={imageUrl}
          alt="Quoted attachment"
          onError={() => setFailedImage(true)}
        />
      ) : mediaLabels[replyTo?.mediaType] ? (
        <span
          className="messageReplyAttachment"
          title={mediaLabels[replyTo.mediaType]}
        >
          <InsertDriveFileOutlinedIcon fontSize="small" />
        </span>
      ) : null}
      {composer && onCancel ? (
        <button
          type="button"
          className="messageReplyCancel"
          aria-label="Cancel reply"
          title="Cancel reply"
          onClick={onCancel}
        >
          <CloseRoundedIcon fontSize="small" />
        </button>
      ) : null}
    </div>
  );
}
